import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=ab3a429e&scoped=true"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"
import style0 from "./Author.vue?vue&type=style&index=0&id=ab3a429e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a429e",
  null
  
)

export default component.exports